export const SET_TOAST_ID = 'SET_TOAST_ID';

export interface SetToastId {
    type: typeof SET_TOAST_ID
}

export type ToastState = Record<string, string>;
